import React, { useContext } from "react";
import LazyLoad from "react-lazy-load";
import formatCurrency from "../../func/currency_formatter";
import { useCalculateProductCardPrice } from "../../func/orderCalculations.js";
import { TemplateContext } from "../../layout";
import TagIcon from "../../utils/images/tagIcon";
import DiscountTagBlock from "../DiscountTagBlock.jsx";

const ProductCardNew = ({ product, modifications, index, type }) => {
  const [templateContext, setTemplateContext] = useContext(TemplateContext);
  const warrantyLabel = window.post_template.checkout_v4_products.tr_checkout_v4_products_warrantyLabel;
  const fallbackImages = window.post_template.checkout_v4_products.checkout_v4_product_images;
  const bundleFallbackImgForSummary = window?.post_template?.checkout_v4_products?.fallback_bundle_summary_img;
  const matchingImage =
    fallbackImages && fallbackImages.find((obj) => obj.product_amount === product.amount)?.product_image;
  const discountAppliedLabel = window.post_template?.checkout_v4_summary?.tr_checkout_v4_discountApplied;

  const { price, oldPrice, promoPrice } = useCalculateProductCardPrice(templateContext.config.product);

  const ProductPriceBlock = (oldPrice, price, promoPrice) => {
    const formattedPrice = window.formattedString.replace(/(0\.00|0,00|0)/, price);
    const formattedPromoPrice = window.formattedString.replace(/(0\.00|0,00|0)/, promoPrice);
    return !templateContext.discountCode ? (
      <div className="productCard__priceBlock">
        {oldPrice && <span className="productCard__priceBlock__oldPrice">{oldPrice}</span>}
        {formattedPrice && <span className="productCard__priceBlock__price">{formattedPrice}</span>}
      </div>
    ) : (
      <div className="productCard__priceBlock">
        {oldPrice && <span className="productCard__priceBlock__oldPrice">{oldPrice}</span>}
        {formattedPromoPrice && <span className="productCard__priceBlock__price">{formattedPromoPrice}</span>}
      </div>
    );
  };

  const fakeProductPrice = window.formattedString
    ? window.formattedString.replace(/(0\.00|0,00|0)/, product.price)
    : formatCurrency(product.price);
  const fakeProductPriceBlock = () => {
    return (
      <div className="productCard__priceBlock">
        <span className="productCard__priceBlock__oldPrice">{fakeProductPrice}</span>
        <span className="productCard__priceBlock__price">{product.price_line_label}</span>
      </div>
    );
  };

  return (
    <div key={index} className={`productCard ${modifications?.DrawerProducts ? "productCard_smallMargin" : ""}`}>
      <div className="productCard__imageContainer">
        <LazyLoad height={64} width={64}>
          <img
            src={bundleFallbackImgForSummary ? bundleFallbackImgForSummary : product?.image?.url}
            alt={general_settings.brand_name}
            className="mon-img-64-w mon-img-64-h"
          />
        </LazyLoad>
        <span data-testid="summary-product-amount" className="productCard__imageContainer__indicator">
          {!templateContext.bundlePrice ? product.amount : 1}
        </span>
      </div>
      <div className="productCard__titleBlock">
        <div data-testid="summary-product-title" className="productCard__titleBlock__title">
          {product.display_name}{" "}
          {type !== "fake" && templateContext.config.warrantyState && (
            <span data-testid="summary-product-title-warr-label">{warrantyLabel}</span>
          )}
        </div>
        {window?.post_template?.checkout_v4_products?.checkout_v4_products_discountAppliedToggle && (
          <DiscountTagBlock discountAppliedLabel={discountAppliedLabel} />
        )}
        {window.productData?.show_bundle_design && product?.bundle_title && (
          <div className="productCard__titleBlock__altText">{product?.bundle_title}</div>
        )}
        {product.tr_additional_texts && (
          <div className="productCard__titleBlock__altText">{product.tr_additional_texts}</div>
        )}
        {type == "fake" ? (
          <>
            {product.tag_label && (
              <div className="productCard__titleBlock__tagText">
                <TagIcon />
                {product.tag_label} {`(-${fakeProductPrice})`}
              </div>
            )}
          </>
        ) : (
          <>
            {templateContext?.discountCode && (
              <DiscountTag price={price} promoPrice={promoPrice} discountCode={templateContext?.discountCode} />
            )}
          </>
        )}
      </div>
      {type !== "fake" ? ProductPriceBlock(oldPrice, price, promoPrice) : fakeProductPriceBlock()}
    </div>
  );
};

function DiscountTag({ price, promoPrice, discountCode }) {
  console.log(price, promoPrice);
  const additionalSavings = (Number(price) - Number(promoPrice)).toFixed(2);
  const additionalSavingsFormatted = window.formattedString.replace(/(0\.00|0,00|0)/, additionalSavings);

  return (
    <div className="productCard__titleBlock__tagText">
      <TagIcon />
      {discountCode} {`(-${additionalSavingsFormatted})`}
    </div>
  );
}

export default ProductCardNew;
